import { ExternalLink } from "lucide-react";
interface Source {
  name: string;
  url?: string;
}
interface SourcesCitationProps {
  sources?: Source[];
  className?: string;
}
const defaultSources: Source[] = [{
  name: "Gallup State of the Global Workplace 2024",
  url: "https://www.gallup.com/workplace/349484/state-of-the-global-workplace.aspx"
}, {
  name: "SHRM Talent Trends 2024",
  url: "https://www.shrm.org/topics-tools/research"
}, {
  name: "Harvard Business School - Amy Edmondson",
  url: "https://www.hbs.edu/faculty/Pages/profile.aspx?facId=6451"
}];
export function SourcesCitation({
  sources = defaultSources,
  className = ""
}: SourcesCitationProps) {
  return <div className={`border-t border-border/50 pt-6 mt-8 ${className}`}>
      <p className="text-xs text-muted-foreground text-center">
        <span className="font-medium">Sources: </span>
        {sources.map((source, index) => <span key={source.name}>
            {source.url ? <a href={source.url} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors inline-flex items-center gap-0.5">
                {source.name}
                <ExternalLink className="h-2.5 w-2.5" />
              </a> : source.name}
            {index < sources.length - 1 && ", "}
          </span>)}
      </p>
    </div>;
}